export const TABLE_HEIGHT = 100
export const TABLE_ROW_HEIGHT = 72
export const ADV_PRODUCT_TABLE_ROW_HEIGHT = 50
export const TABLE_COLUMN_WIDTH = 100
